import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_numerica.png",
      alt: "Estratégias Numerica",
    },
    title: "Aumente os seus rendimentos com a Numerica",

    // String ou array de strings
    text: "Adicione ao seu portfólio estratégias criadas e validadas por profissionais que vivem há mais de 15 anos no mercado mais competitivo do mundo, entregando a mais alta performance e o mais eficiente gerenciamento de risco",
    testimonial: {
      text: "No mercado, se adaptar é a chave para a consistência - e é exatamente assim que nosso algoritmo se prepara para cada ciclo do mercado",
      author: {
        name: "Henrique Cottini, Estrategista Chefe da Numerica",
        // picture: 'https://ontick-img.s3.sa-east-1.amazonaws.com/raphael_qgdotrader_profile.png',
      },
    },
  },

  strategies: {
    title: "Estratégias Numerica",
    heading: "Poderosas estratégias - agora pra você",
    subtitle: "Conheça as técnicas disponíveis na plataforma",
  },

  cta: {
    title: "Vamos começar?",
    subtitle: "Ative a extensão Numerica agora mesmo.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Numerica",
    col1: [
      "Buscamos utilizar algoritmos sofisticados para gerar e aprimorar ativamente as nossas estratégias, fornecendo seus sinais baseados na mais pura análise quantitativa.",
    ],
    // col2: [
    //   "Nosso time de profissionais tem longa experiência no mercado financeiro e tem certeza que operar baseado em estatística é o caminho certo para o investidor que leva a sério o mercado financeiro.",
    // ],
  },

  stats: {
    title: "Como a Numerica é vista no mercado",
    // subtitle: "Um portfólio de estratégias testadas e validadas",
    data: [
      {
        value: "+1M",
        description: "Patrimônio gerado",
      },
      {
        value: "+15",
        description: "Anos de experiência",
      },
      {
        value: "+3",
        description: "Desenvolvendo algoritmos",
      },
    ],
  },

  features: {
    type: 1,
    title: "Por quê utilizar os robôs da Numerica",
    subtitle: "Veja quais as principais vantagens em escolher os nossos robôs.",
    data: [
      {
        icon: iconsSet.charts,
        title: "Evolução constante",
        description:
          "As estratégias são atualizadas visando sempre a maior performance. Se o mercado muda, nós também.",
      },
      {
        icon: iconsSet.infinite,
        title: "Para qualquer operacional",
        description:
          "Temos estratégias scalpers até estratégias com operações que duram horas.",
      },
      {
        icon: iconsSet.group,
        title: "Para todo mundo",
        description:
          "Seja fazendo uma ou várias operações por dia, você vai encontrar a estratégia que procura conosco.",
      },

      ...defaultContent.features.data,
    ],
  },

  // testimonials: [
  //   {
  //     text: "Eu aprendo muito com a Nine. Sempre me atenderam muito bem, passando tranquilidade, compartilhando conhecimento e muito preocupados com o resultado.",
  //     author: "Bruna Maicá da Silveira",
  //     job: "Administradora",
  //     // image_url:
  //     //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
  //   },
  //   {
  //     text: "O Deividi entende muito de trade! Estou com a Nine desde o começo e já tenho resultados consistentes.",
  //     author: "Jonathan Delgado Reis",
  //     job: "Engenheiro",
  //     // image_url:
  //     //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
  //   },
  // ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Numerica",
  },
};
